// 工作流公用方法
export default {
  //    列表页 操作按钮判断
  /**
   * @param {*} btnType 按钮类型 如驳回按钮 approval
   * @param {*} approvalState 审批状态
   * @param {*} staffGuid 当前登录人guid
   * @param {*} submitStaffGuid 提交人staffGuid
   * @param {*} approvalStaffGuid 审批人staffGuid
   *@param {*} bizApproveState 销毁状态
   * @returns
   *  <!-- 审批状态 审批中 A 已通过 Y 已驳回 R 已撤销 C 草稿中N-->
   */
  getListBtnState(btnType, approvalState, submitStaffGuid, approvalStaffGuid, staffGuid, bizApproveState) {
    if (Array.isArray(approvalStaffGuid)) {
      approvalStaffGuid.forEach(i=>{
        if(i == staffGuid){
          approvalStaffGuid = i;
        }
      })
    }
    //通过驳回按钮 当审批状态为审批中A且审批人为当前登录人时展示
    if (btnType == 'approval' && approvalState == 'A' && approvalStaffGuid == staffGuid) {
      return 'approval';
    }
    // 撤销按钮显示 当审批状态为审批中A且提交人为当前登录人时展示
    else if (btnType == 'revoke' && approvalState == 'A' && submitStaffGuid == staffGuid) {
      return 'revoke';
    }
    // 详情按钮显示 当状态不为草稿中N时展示
    else if (btnType == 'detail' && approvalState !== 'N') {
      return 'detail';
    }
    //重新提交按钮 当审批状态为驳回R或撤销C且提交人为当前登录人且bizApproveState 不为D时展示
    else if (
      btnType == 'again' &&
      (approvalState == 'R' || approvalState == 'C') &&
      submitStaffGuid == staffGuid &&
      bizApproveState !== 'D'
    ) {
      return 'again';
    }
    //编辑 当审批状态为草稿中提交人为当前登录人时展示
    else if (btnType == 'edit' && approvalState == 'N' && submitStaffGuid == staffGuid) {
      return 'edit';
    }
    //删除 当审批状态为草稿N、已驳回R、已撤销C且提交人为当前登录人时展示
    else if (
      (btnType == 'del' && (approvalState == 'R' || approvalState == 'C') && submitStaffGuid == staffGuid) ||
      (approvalState == 'N' && submitStaffGuid == staffGuid)
    ) {
      return 'del';
    }
  },

  //    详情页通过驳回等按钮判断
  /**
   *
   * @param {*} approvalState 审批状态
   * @param {*} approvalStaffGuid 审批人staffguid
   * @param {*} staffGuid 当前登录人guid
   * @param {*} submitStaffGuid 提交人staffGuid
   * @param {*} type 按钮类型
   * * @param {*} bizApproveState 是否重新提交为D则不显示
   * @returns
   *  <!-- 审批状态 审批中 A 已通过 Y 已驳回 R 已撤销 C -->
   */
  getBtnState(type, approvalState, approvalStaffGuid, staffGuid, submitStaffGuid,bizApproveState) {
    if (Array.isArray(approvalStaffGuid)) {
      approvalStaffGuid.forEach(i=>{
        if(i == staffGuid){
          approvalStaffGuid = i;
        }
      })
    }
    //通过驳回按钮  当审批状态为审批中A时且当前审批人为当前登录人时展示
    if (type == 'approval' && approvalState == 'A' && approvalStaffGuid == staffGuid) {
      return 'approval';
      //重新提交按钮 当审批状态为驳回R或撤销C且提交人为当前登录人时展示
    } else if (type == 'again' && (approvalState == 'R' || approvalState == 'C') && submitStaffGuid == staffGuid && bizApproveState !== 'D') {
      return 'again';
      //是否撤销 当审批状态为审批中A时且提交人为当前登录人时展示
    } else if (type == 'revoke' && approvalState == 'A' && submitStaffGuid == staffGuid) {
      return 'revoke';
    }
  },
  //获取审批状态样式
  getStateClass(approvalState) {
    let str = 'approve-state approve-state-C';
    switch (approvalState) {
      case 'A':
        str = 'approve-state approve-state-A';
        break;
      case 'Y':
        str = 'approve-state approve-state-Y';
        break;
      case 'R':
        str = 'approve-state approve-state-R';
        break;
      case 'N':
        str = 'approve-state approve-state-C';
        break;
      case 'C':
        str = 'approve-state approve-state-C';
        break;
    }
    return str;
  },
  // 详情页审批状态图片
  getApproveImg(approvalState) {
    let str = null;
    switch (approvalState) {
      case 'A':
        str = require('@/assets/images/ic_shenping.png');
        break;
      case 'Y':
        str = require('@/assets/images/ic_pass.png');
        break;
      case 'R':
        str = require('@/assets/images/ic_reject.png');
        break;
      case 'C':
        str = require('@/assets/images/ic_cancel.png');
        break;
    }
    return str;
  },
};
